export const MuiDrawer = (paperBackground: string, borderColor: string, textColor: string) => ({
  styleOverrides: {
    root: {
      '& .MuiPaper-root': {
        backgroundColor: paperBackground,
        color: textColor,
        height: '100vh',
        border: '0px',
        borderRight: `1px solid ${borderColor}`,
      },
      '& .MuiListItemIcon-root': {
        alignItems: 'center',
        color: 'inherit',
        minWidth: 'auto',
      },
      '& .MuiListItem-root': {
        padding: '0px',
      },
    },
  },
});
